import React from 'react'
import cn from 'classnames'

import { IBarChartGroupedReviewerType } from '../BarChartGrouped/interface'
import { T1, T2 } from 'app/constants/reviews'
// @ts-ignore
import * as reports from 'app/domains/routes/Reports/Reports'
import { ITitleForRadarAndBarProps } from './interface'

import './styles.scss'
const bc = 'title-for-radar-and-bar'

const TitleForRadarAndBar: React.FC<ITitleForRadarAndBarProps> = ({
  data,
  reviewerType = '',
  title,
  subtitle,
  classNameTitle,
}) => {
  return (
    <div className={`${bc}__wrapper`}>
      <div className={`${bc}__title-wrapper`}>
        <div className={cn({ [`${classNameTitle}`]: !!classNameTitle })}>{title}</div>
        <div className={`${bc}__legends`}>
          <div className={`${bc}__legend`}>
            {data ? (
              data.map((el: IBarChartGroupedReviewerType) => {
                return (
                  <div
                    key={`${el.reviewerType}_${el.t1}`}
                    className={`${bc}__legend-circle`}
                    style={{ backgroundColor: reports.COLORS_FOR_RADAR_CHART_T2[T1][el.reviewerType] }}
                  />
                )
              })
            ) : (
              <div
                className={`${bc}__legend-circle`}
                style={{ backgroundColor: reports.COLORS_FOR_RADAR_CHART_T2[T1][reviewerType] }}
              />
            )}
            <div>T1</div>
          </div>
          <div className={`${bc}__legend`}>
            {data ? (
              data.map((el: IBarChartGroupedReviewerType) => {
                return (
                  <div
                    key={`${el.reviewerType}_${el.t2}`}
                    className={`${bc}__legend-circle`}
                    style={{ backgroundColor: reports.COLORS_FOR_RADAR_CHART_T2[T2][el.reviewerType] }}
                  />
                )
              })
            ) : (
              <div
                className={`${bc}__legend-circle`}
                style={{ backgroundColor: reports.COLORS_FOR_RADAR_CHART_T2[T2][reviewerType] }}
              />
            )}
            <div>T2</div>
          </div>
        </div>
      </div>
      {subtitle && <div className={`${bc}__subtitle-wrapper`}>{reviewerType}</div>}
    </div>
  )
}

export default TitleForRadarAndBar
